import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from 'flarum/forum/app';
import Page from 'flarum/common/components/Page';
import Link from 'flarum/common/components/Link';
import Button from 'flarum/common/components/Button';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import { normalizeSearchText, matchesSearch } from '../../common/utils/normalize';
export default class EditMatchParticipantesPage extends Page {
  constructor() {
    super(...arguments);
    _defineProperty(this, "match", null);
    _defineProperty(this, "loading", true);
    _defineProperty(this, "canManage", false);
    _defineProperty(this, "saving", false);
    // Pool of all active players
    _defineProperty(this, "players", []);
    // Unified list of chosen player IDs (max 16)
    _defineProperty(this, "chosenIds", []);
    // Search and Autocomplete state
    _defineProperty(this, "searchText", '');
    _defineProperty(this, "showSuggestions", false);
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.canManage = !!(app.forum.attribute('canManagePlayers') || app.session.user && (app.session.user.attribute('canManagePlayers') || app.session.user.isAdmin()));
    if (!this.canManage) {
      m.route.set('/');
      return;
    }
    const id = m.route.param('id');
    this.loadAllData(id);
  }
  loadAllData(id) {
    this.loading = true;
    m.redraw();
    const promises = [app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + "/nagusi/match-ratings/matches/".concat(id, "?include=players,discussion,season,preMatchDiscussion,bolillaDiscussion")
    }), app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + '/nagusi/match-ratings/players?include=teams'
    })];
    Promise.all(promises).then(responses => {
      app.store.pushPayload(responses[0]);
      this.players = app.store.pushPayload(responses[1]);
      this.match = app.store.getById('nagusi_matches', id);
      if (this.match) {
        this.initForm();
      } else {
        app.alerts.show({
          type: 'error'
        }, app.translator.trans('bizkaitarra-lineup.forum.matches.alerts.error_not_found'));
        m.route.set(app.route('bizkaitarra-lineup.matches'));
      }
      this.loading = false;
      m.redraw();
    }).catch(error => {
      console.error('Error loading lineup editor data:', error);
      app.alerts.show({
        type: 'error'
      }, app.translator.trans('bizkaitarra-lineup.forum.matches.alerts.error_load'));
      m.route.set(app.route('bizkaitarra-lineup.matches'));
      this.loading = false;
      m.redraw();
    });
  }
  initForm() {
    this.chosenIds = [];
    const allMatchPlayers = this.match.players() || [];

    // Exclude coaches and team entities from player participants list
    const standardPlayers = allMatchPlayers.filter(p => {
      const type = p.attribute('entityType');
      return type !== 'coach' && type !== 'team' && p.id() !== '1582' && p.id() !== '99999999';
    });

    // Populate our single unified list sequentially
    standardPlayers.forEach(p => {
      this.chosenIds.push(p.id());
    });
  }
  addPlayer(playerId) {
    if (this.chosenIds.includes(playerId)) return;
    if (this.chosenIds.length >= 16) {
      app.alerts.show({
        type: 'error'
      }, app.translator.trans('bizkaitarra-lineup.forum.matches.alerts.limit_reached'));
      return;
    }
    this.chosenIds.push(playerId);
    this.searchText = '';
    this.showSuggestions = false;
    m.redraw();
  }
  removePlayer(index) {
    this.chosenIds.splice(index, 1);
    m.redraw();
  }
  moveUp(index, e) {
    e.preventDefault();
    if (index <= 0) return;
    const temp = this.chosenIds[index];
    this.chosenIds[index] = this.chosenIds[index - 1];
    this.chosenIds[index - 1] = temp;
    m.redraw();
  }
  moveDown(index, e) {
    e.preventDefault();
    if (index >= this.chosenIds.length - 1) return;
    const temp = this.chosenIds[index];
    this.chosenIds[index] = this.chosenIds[index + 1];
    this.chosenIds[index + 1] = temp;
    m.redraw();
  }
  saveLineup(e) {
    e.preventDefault();
    this.saving = true;
    const method = 'PATCH';
    const url = app.forum.attribute('apiUrl') + '/nagusi/match-ratings/matches/' + this.match.id();

    // First 11 are starters (Titulares)
    const titulares = this.chosenIds.slice(0, 11);
    // The remaining are substitutes (Suplentes / Cambios) (max 5)
    const suplentes = this.chosenIds.slice(11);

    // Assemble sequential list transparently injecting special IDs in the middle
    const sortedPlayerIds = [...titulares, '1582', '99999999', ...suplentes];
    app.request({
      method,
      url,
      body: {
        data: {
          type: 'nagusi_matches',
          id: this.match.id(),
          relationships: {
            players: {
              data: sortedPlayerIds.map(id => ({
                type: 'nagusi_players',
                id
              }))
            }
          }
        }
      }
    }).then(res => {
      if (res && res.meta && typeof res.meta.pendingCount !== 'undefined') {
        if (!app.forum.data.attributes) {
          app.forum.data.attributes = {};
        }
        app.forum.data.attributes.pendingTaldezainaTasksCount = res.meta.pendingCount;
      }
      this.saving = false;
      app.alerts.show({
        type: 'success'
      }, app.translator.trans('bizkaitarra-lineup.forum.matches.alerts.success_roster'));
      m.route.set(app.route('bizkaitarra-lineup.matches'));
    }).catch(error => {
      console.error('Error saving lineup:', error);
      this.saving = false;
      if (error && error.response && error.response.errors) {
        const firstErr = error.response.errors[0];
        if (firstErr && firstErr.detail) {
          app.alerts.show({
            type: 'error'
          }, firstErr.detail);
        } else {
          app.alerts.show({
            type: 'error'
          }, app.translator.trans('bizkaitarra-lineup.forum.matches.alerts.error_save'));
        }
      } else {
        app.alerts.show({
          type: 'error'
        }, app.translator.trans('bizkaitarra-lineup.forum.matches.alerts.error_validation'));
      }
      m.redraw();
    });
  }
  getAllowedTeamIds() {
    const primaryTeamId = this.match && typeof this.match.teamId === 'function' && this.match.teamId() ? String(this.match.teamId()) : String(app.forum.attribute('nagusiMatchRatingsPrimaryTeamId') || '531');
    const isRealSociedad = app.forum.attribute('nagusiMatchRatingsClubSlug') === 'real-sociedad';
    if (isRealSociedad) {
      return [primaryTeamId];
    }

    // Athletic Club primer equipo (531): permite Primer Equipo (531), Bilbao Athletic (9579) y Basconia (9656)
    if (primaryTeamId === '531') {
      return ['531', '9579', '9656'];
    }

    // Bilbao Athletic (9579): permite Bilbao Athletic (9579) y Basconia (9656)
    if (primaryTeamId === '9579') {
      return ['9579', '9656'];
    }

    // Basconia (9656): permite Basconia (9656)
    if (primaryTeamId === '9656') {
      return ['9656'];
    }
    return [primaryTeamId];
  }
  getPlayerTeamBadge(player) {
    const teams = player.teams() || [];
    const isBA = teams.some(t => String(t.id()) === '9579');
    const isBasconia = teams.some(t => String(t.id()) === '9656');
    const isFirstTeam = teams.some(t => String(t.id()) === '531');
    if (isFirstTeam && !isBA && !isBasconia) {
      return null;
    }
    if (isBA) {
      return m("span", {
        className: "Player-teamBadge Player-teamBadge--ba",
        style: "font-size: 0.72em; font-weight: 700; padding: 2px 7px; border-radius: 4px; background: rgba(239, 83, 80, 0.15); color: #ef9a9a; border: 1px solid rgba(239, 83, 80, 0.3); flex-shrink: 0;"
      }, "Bilbao Athletic");
    }
    if (isBasconia) {
      return m("span", {
        className: "Player-teamBadge Player-teamBadge--basconia",
        style: "font-size: 0.72em; font-weight: 700; padding: 2px 7px; border-radius: 4px; background: rgba(255, 152, 0, 0.15); color: #ffcc80; border: 1px solid rgba(255, 152, 0, 0.3); flex-shrink: 0;"
      }, "Basconia");
    }
    return null;
  }
  view() {
    if (!this.canManage) return null;
    if (this.loading) {
      return m("div", {
        className: "EditMatchParticipantesPage"
      }, m("div", {
        className: "container",
        style: "padding: 40px; text-align: center;"
      }, m(LoadingIndicator, null)));
    }
    const allowedTeamIds = this.getAllowedTeamIds();

    // Filter and suggest players belonging to allowed teams, active, excluding Valverde & Athletic, and not selected yet
    let suggestions = [];
    if (this.searchText.trim()) {
      const query = normalizeSearchText(this.searchText);
      suggestions = this.players.filter(p => {
        if (p.attribute('entityType') === 'coach' || p.attribute('entityType') === 'team' || p.id() === '1582' || p.id() === '99999999') return false;

        // Check active
        if (p.isActive && p.isActive() === false) return false;

        // Check team matching
        const playerTeamIds = (p.teams() || []).map(t => String(t.id()));
        if (!playerTeamIds.some(id => allowedTeamIds.includes(id))) return false;

        // Exclude already selected
        if (this.chosenIds.includes(p.id())) return false;

        // Search query matching (accent-insensitive)
        const nameMatch = p.name() ? matchesSearch(p.name(), query) : false;
        const aliases = (p.attribute('aliases') || '').split(/[;,]/);
        const aliasMatch = aliases.some(a => matchesSearch(a, query));
        return nameMatch || aliasMatch;
      }).sort((a, b) => {
        const aTeams = (a.teams() || []).map(t => String(t.id()));
        const bTeams = (b.teams() || []).map(t => String(t.id()));
        const aIsFirstTeam = aTeams.includes('531');
        const bIsFirstTeam = bTeams.includes('531');
        if (aIsFirstTeam !== bIsFirstTeam) {
          return aIsFirstTeam ? -1 : 1;
        }
        const aIsBA = aTeams.includes('9579');
        const bIsBA = bTeams.includes('9579');
        if (aIsBA !== bIsBA) {
          return aIsBA ? -1 : 1;
        }
        const numA = parseInt(a.number() || '999');
        const numB = parseInt(b.number() || '999');
        if (numA !== numB) return numA - numB;
        return a.name().localeCompare(b.name());
      }).slice(0, 10); // Suggest top 10 matches
    }
    return m("div", {
      className: "EditMatchParticipantesPage"
    }, m("div", {
      className: "container",
      style: "padding-top: 40px; padding-bottom: 40px;"
    }, m("div", {
      className: "Taldezaina-navigation",
      style: "display: flex; gap: 15px; margin-bottom: 40px;"
    }, m(Link, {
      href: app.route('bizkaitarra-lineup.matches'),
      className: "Button Button--secondary",
      style: "display: inline-flex; align-items: center; gap: 8px; font-weight: bold; border-radius: 8px; padding: 10px 16px; border: 1px solid rgba(255, 255, 255, 0.15); background: rgba(255, 255, 255, 0.05); transition: background 0.2s ease, border-color 0.2s ease;"
    }, m("i", {
      className: "fas fa-arrow-left"
    }), app.translator.trans('bizkaitarra-lineup.forum.matches.nav_back_matches')), m(Link, {
      href: app.route('bizkaitarra-lineup.taldezaina'),
      className: "Button Button--secondary",
      style: "display: inline-flex; align-items: center; gap: 8px; font-weight: bold; border-radius: 8px; padding: 10px 16px; border: 1px solid rgba(255, 255, 255, 0.15); background: rgba(255, 255, 255, 0.05); transition: background 0.2s ease, border-color 0.2s ease;"
    }, m("i", {
      className: "fas fa-user-shield"
    }), app.translator.trans('bizkaitarra-lineup.forum.matches.nav_back_taldezaina'))), m("div", {
      className: "EditMatch-header",
      style: "margin-bottom: 30px;"
    }, m("h2", {
      style: "font-size: 2.2em; font-weight: 800; color: var(--heading-color); margin: 0; letter-spacing: -0.02em;"
    }, app.translator.trans('bizkaitarra-lineup.forum.matches.edit_roster_title')), m("p", {
      style: "color: var(--muted-color); font-size: 1.25em; margin-top: 4px;"
    }, this.match.getName())), m("form", {
      onsubmit: this.saveLineup.bind(this)
    }, m("div", {
      style: "max-width: 650px; background: rgba(255,255,255,0.03); border: 1px solid rgba(255,255,255,0.08); border-radius: 16px; padding: 30px; display: flex; flex-direction: column; gap: 25px; box-shadow: 0 8px 32px rgba(0,0,0,0.15);"
    }, m("div", {
      style: "position: relative; display: flex; flex-direction: column; gap: 8px;"
    }, m("label", {
      style: "font-weight: bold; color: var(--muted-color); font-size: 0.95em;"
    }, m("i", {
      className: "fas fa-user-plus",
      style: "margin-right: 6px; color: #ff9800;"
    }), app.translator.trans('bizkaitarra-lineup.forum.matches.field_add_player')), m("div", {
      style: "position: relative; display: flex; align-items: center;"
    }, m("i", {
      className: "fas fa-search",
      style: "position: absolute; left: 14px; color: var(--muted-color); font-size: 0.95em;"
    }), m("input", {
      className: "FormControl",
      placeholder: app.translator.trans('bizkaitarra-lineup.forum.matches.player_search_placeholder'),
      value: this.searchText,
      oninput: e => {
        this.searchText = e.target.value;
        this.showSuggestions = true;
        m.redraw();
      },
      onfocus: () => {
        this.showSuggestions = true;
      },
      style: "padding-left: 38px; border-radius: 8px;"
    }), this.searchText.trim() && m("i", {
      className: "fas fa-times-circle",
      style: "position: absolute; right: 14px; color: var(--muted-color); cursor: pointer; font-size: 1.05em;",
      onclick: () => {
        this.searchText = '';
        this.showSuggestions = false;
      }
    })), this.showSuggestions && suggestions.length > 0 && m("ul", {
      style: "border: 1px solid rgba(255,255,255,0.15); border-radius: 8px; padding: 5px 0; margin-top: 5px; list-style: none; max-height: 250px; overflow-y: auto; background: #252830; position: absolute; z-index: 100; width: 100%; box-shadow: 0 8px 24px rgba(0,0,0,0.5); top: 100%;"
    }, suggestions.map(player => m("li", {
      key: player.id(),
      style: "padding: 10px 14px; cursor: pointer; border-bottom: 1px solid rgba(255,255,255,0.05); color: #fff; font-size: 0.95em; transition: background 0.2s; display: flex; align-items: center; justify-content: space-between;",
      onclick: () => this.addPlayer(player.id()),
      oncreate: vn => {
        const el = vn.dom;
        el.addEventListener('mouseenter', () => el.style.background = 'rgba(255,255,255,0.08)');
        el.addEventListener('mouseleave', () => el.style.background = 'transparent');
      }
    }, m("div", {
      style: "display: flex; align-items: center; gap: 10px; overflow: hidden;"
    }, m("div", {
      className: "Desktop-Only",
      style: "display: flex; align-items: center; flex-shrink: 0;"
    }, player.photoUrl() ? m("img", {
      src: player.photoUrl(),
      style: "width: 26px; height: 26px; border-radius: 50%; object-fit: cover;"
    }) : m("div", {
      style: "width: 26px; height: 26px; border-radius: 50%; background: rgba(255,255,255,0.1); display: flex; align-items: center; justify-content: center; font-size: 0.75em; font-weight: bold; color: var(--muted-color);"
    }, player.name().substring(0, 2).toUpperCase())), m("span", {
      style: "font-weight: bold; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"
    }, player.name()), this.getPlayerTeamBadge(player)), m("span", {
      style: "font-size: 0.85em; color: var(--muted-color); font-weight: bold; margin-left: 8px; flex-shrink: 0;"
    }, player.number() ? "#".concat(player.number()) : '#--'))))), m("div", {
      style: "display: flex; flex-direction: column; gap: 12px; margin-top: 10px;"
    }, m("div", {
      style: "display: flex; justify-content: space-between; align-items: center; border-bottom: 1px solid rgba(255,255,255,0.08); padding-bottom: 8px; margin-bottom: 5px;"
    }, m("h3", {
      style: "font-size: 1.25em; font-weight: bold; margin: 0; color: var(--heading-color);"
    }, app.translator.trans('bizkaitarra-lineup.forum.matches.roster_list_title'), " (", this.chosenIds.length, " / 16)")), this.chosenIds.length > 0 ? m("div", {
      style: "display: flex; flex-direction: column; gap: 8px;"
    }, this.chosenIds.map((pId, index) => {
      const player = app.store.getById('nagusi_players', pId);
      if (!player) return null;
      const isStarter = index < 11;

      // Starters (Titulares) styling vs Substitutes (Suplentes) styling
      const itemStyle = isStarter ? "background: rgba(76, 175, 80, 0.05); border: 1px solid rgba(76, 175, 80, 0.2);" : "background: rgba(33, 150, 243, 0.05); border: 1px solid rgba(33, 150, 243, 0.2);";
      const tagStyle = isStarter ? "background: rgba(76, 175, 80, 0.15); color: #81c784; border: 1px solid rgba(76, 175, 80, 0.25);" : "background: rgba(33, 150, 243, 0.15); color: #90caf9; border: 1px solid rgba(33, 150, 243, 0.25);";
      return m("div", {
        key: pId,
        style: "border-radius: 12px; padding: 10px 15px; display: flex; align-items: center; justify-content: space-between; gap: 10px; height: 58px; transition: all 0.2s; ".concat(itemStyle)
      }, m("div", {
        style: "display: flex; align-items: center; gap: 12px; overflow: hidden; flex-grow: 1;"
      }, m("div", {
        style: "width: 26px; height: 26px; border-radius: 50%; display: flex; align-items: center; justify-content: center; font-weight: 800; font-size: 0.85em; background: ".concat(isStarter ? '#4caf50' : '#2196f3', "; color: #fff; flex-shrink: 0;")
      }, index + 1), m("div", {
        className: "Desktop-Only",
        style: "display: flex; align-items: center; flex-shrink: 0;"
      }, player.photoUrl() ? m("img", {
        src: player.photoUrl(),
        style: "width: 32px; height: 32px; border-radius: 50%; object-fit: cover; border: 1px solid rgba(255,255,255,0.1); flex-shrink: 0;"
      }) : m("div", {
        style: "width: 32px; height: 32px; border-radius: 50%; background: rgba(255,255,255,0.06); display: flex; align-items: center; justify-content: center; font-size: 0.8em; font-weight: bold; color: var(--muted-color); border: 1px solid rgba(255,255,255,0.03); flex-shrink: 0;"
      }, player.name().substring(0, 2).toUpperCase())), m("div", {
        style: "overflow: hidden; text-overflow: ellipsis; white-space: nowrap; display: flex; align-items: center; gap: 10px;"
      }, m("span", {
        style: "font-weight: 700; color: var(--heading-color, #fff); font-size: 1.05em; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;"
      }, player.name()), this.getPlayerTeamBadge(player), m("span", {
        className: "Desktop-Only",
        style: "font-size: 0.78em; font-weight: bold; padding: 2px 8px; border-radius: 4px; uppercase; flex-shrink: 0; ".concat(tagStyle)
      }, isStarter ? app.translator.trans('bizkaitarra-lineup.forum.matches.player_tag_starter') : app.translator.trans('bizkaitarra-lineup.forum.matches.player_tag_substitute')))), m("div", {
        style: "display: flex; align-items: center; gap: 4px; flex-shrink: 0;"
      }, m("button", {
        type: "button",
        className: "Button Button--icon Button--link",
        disabled: index === 0,
        onclick: e => this.moveUp(index, e),
        style: "color: #bbb; padding: 4px; font-size: 1.05em; opacity: index === 0 ? 0.3 : 1;",
        title: app.translator.trans('bizkaitarra-lineup.forum.matches.btn_up')
      }, m("i", {
        className: "fas fa-arrow-up"
      })), m("button", {
        type: "button",
        className: "Button Button--icon Button--link",
        disabled: index === this.chosenIds.length - 1,
        onclick: e => this.moveDown(index, e),
        style: "color: #bbb; padding: 4px; font-size: 1.05em; opacity: index === this.chosenIds.length - 1 ? 0.3 : 1;",
        title: app.translator.trans('bizkaitarra-lineup.forum.matches.btn_down')
      }, m("i", {
        className: "fas fa-arrow-down"
      })), m("span", {
        style: "width: 1px; height: 18px; background: rgba(255,255,255,0.12); margin: 0 4px;"
      }), m(Button, {
        type: "button",
        className: "Button Button--icon Button--link",
        icon: "fas fa-times-circle",
        style: "color: #ef5350; font-size: 1.15em; padding: 4px;",
        onclick: () => this.removePlayer(index),
        title: app.translator.trans('bizkaitarra-lineup.forum.matches.btn_remove')
      })));
    })) : m("div", {
      style: "text-align: center; color: var(--muted-color); padding: 40px 10px; font-style: italic; font-size: 0.95em; background: rgba(0,0,0,0.1); border-radius: 12px; border: 1px dashed rgba(255,255,255,0.06);"
    }, app.translator.trans('bizkaitarra-lineup.forum.matches.roster_empty_help'))), m("div", {
      style: "display: flex; justify-content: flex-end; gap: 15px; border-top: 1px solid rgba(255,255,255,0.08); padding-top: 20px; margin-top: 10px;"
    }, m(Link, {
      href: app.route('bizkaitarra-lineup.matches'),
      className: "Button",
      style: "border-radius: 8px; padding: 10px 20px; font-weight: bold; height: 42px; display: inline-flex; align-items: center;"
    }, app.translator.trans('bizkaitarra-lineup.forum.matches.btn_cancel')), m(Button, {
      type: "submit",
      className: "Button Button--primary",
      loading: this.saving,
      style: "border-radius: 8px; padding: 10px 26px; font-weight: bold; display: inline-flex; align-items: center; gap: 8px; height: 42px;"
    }, m("i", {
      className: "fas fa-save"
    }), " ", app.translator.trans('bizkaitarra-lineup.forum.matches.btn_save_roster')))))));
  }
}
flarum.reg.add('nagusi-match-ratings', 'forum/match-rating/EditMatchParticipantesPage', EditMatchParticipantesPage);